import { usePreviewAccessCode } from "../hooks/usePreviewAccessCode";

/**
 * Renders nothing. Mounted in the app shell so the current preview access code is fetched once and
 * published to siteLinks (buildPublicUrl) : every admin→preview link then carries `?ac=…` and editors
 * are never prompted by the preview gate.
 */
export const PreviewAccessCodeLoader = (): null => {
	usePreviewAccessCode();
	return null;
};
